import {
  ITaxEstimate,
  ITaxEstimateBase
} from "@wingspanhq/bookkeeping/dist/lib/interfaces/taxEstimate";
import { WSQueryConfig } from "@ws-react-query";
import bookkeepingService from "../../services/bookkeeping";
import { useWSQuery } from "../helpers";
import { QUERY_TAXES_TAX_ESTIMATE } from "./keys";

export const useQueryTaxEstimate = (
  options: ITaxEstimateBase,
  queryConfig?: WSQueryConfig<ITaxEstimate, unknown>
) =>
  useWSQuery(
    [QUERY_TAXES_TAX_ESTIMATE, options],
    async () => await bookkeepingService.createTaxEstimate(options),
    {
      retry: false,
      ...queryConfig
    }
  );
